import { createContext, useContext, useState } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  const addItem = (item) => {
    setItems((prev) => [...prev, { ...item, id: Date.now() + Math.random() }]);
  };
  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  const totalQuantity = items.reduce((sum, i) => sum + i.quantity, 0);
  const rawTotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const hasDiscount = totalQuantity >= 2;
  const finalTotal = hasDiscount ? Math.round(rawTotal * 0.9) : rawTotal;

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, clear, cartOpen, setCartOpen, totalQuantity, rawTotal, finalTotal, hasDiscount }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
};
